<template>
    <div class="panel panel-flat">
        <div class="panel-heading">
            {{transEdit('coupons')}}
        </div>
        <div class="panel-body">

        </div>
    </div>
</template>

<script>
    export default {
        name: "admin-dash-coupons"
    }
</script>

<style scoped>

</style>